const styles = () => ({
  loggerWrapper: {
    position: 'relative',
    marginBottom: 10,
  },
  appVersion: {
    position: 'absolute',
    right: 0,
    bottom: -30,
    fontSize: '12px',
  },
  areaField: {
    width: '100%',
    margin: 0,
    verticalAlign: 'center',
  },
  clearButton: {
    height: 30,
    fontSize: '12px',
    zIndex: 99,
    position: 'absolute',
    right: 10,
    top: 10,
    background: 'rgba(0, 0, 0, 0.54)',
    '&:hover': {
      background: 'rgba(0, 0, 0, 0.44)',
    },
  },
  '@media (max-width: 500px)': {
    clearButton: {
      fontSize: '8px',
      top: -40,
    },
  },
})

export default styles
